module.exports = __webpack_public_path__ + "img/gantt.da94572e.png";